/* eslint-disable no-tabs */
const IconMinusSvg = (props: any) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M5 11.1738H19V13.1738H5V11.1738Z" fill="white" />
    </svg>
  )
}

export default IconMinusSvg
